import { i18n } from '@/i18n'
export default [
  {
    path: 'trash',
    name: 'trash',
    redirect: { name: 'trash/notifications' }
  },
  {
    path: 'trash',
    name: 'trashad',
    redirect: { name: 'trash/companies' }
  },
  {
    path: 'trash/notifications',
    name: 'trash/notifications',
    component: () => import('@/views/trash/Notifications.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('trash.notifications') }
  },
  {
    path: 'trash/notifications/:id/details',
    name: 'trash/notifications/details',
    component: () => import('@/views/trash/Notification.vue'),
    meta: { secondaryMenu: 'configurations/trash/notifications', registerNavFromMenu: false, title: i18n.t('app.notification_detail') }
  },
  {
    path: 'trash/notifications/:id/historical',
    name: 'trash/notifications/historical',
    component: () => import('@/views/historical/TrashNEOHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/notifications', registerNavFromMenu: false, title: i18n.t('historical.by_NEO') }
  },
  {
    path: 'trash/companies',
    name: 'trash/companies',
    component: () => import('@/views/trash/Companies.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('trash.companies') }
  },
  {
    path: 'trash/companies/:id/details',
    name: 'trash/companies/details',
    component: () => import('@/views/trash/Company.vue'),
    meta: { secondaryMenu: 'configurations/trash/companies', registerNavFromMenu: false, title: i18n.t('app.company_detail') }
  },
  {
    path: 'trash/companies/:id/historical',
    name: 'trash/companies/historical',
    component: () => import('@/views/historical/TrashCompanyHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/companies', registerNavFromMenu: false, title: i18n.t('historical.by_company') }
  },
  {
    path: 'trash/certificates',
    name: 'trash/certificates',
    component: () => import('@/views/trash/Certificates.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('trash.certificates') }
  },
  {
    path: 'trash/certificates/:idEmpresa/:serial/:tipo/details',
    name: 'trash/certificates/details',
    component: () => import('@/views/trash/Certificate.vue'),
    meta: { secondaryMenu: 'configurations/trash/certificates', registerNavFromMenu: false, title: i18n.t('app.certificate_detail') }
  },
  {
    path: 'trash/certificates/:idEmpresa/:serial/:tipo/historical',
    name: 'trash/certificates/historical',
    component: () => import('@/views/historical/TrashCertificateHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/certificates', registerNavFromMenu: false, title: i18n.t('historical.by_certificate') }
  },
  {
    path: 'trash/users',
    name: 'trash/users',
    component: () => import('@/views/trash/Users.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('trash.users') }
  },
  {
    path: 'trash/users/:id/details',
    name: 'trash/users/details',
    component: () => import('@/views/trash/User.vue'),
    meta: { secondaryMenu: 'configurations/trash/users', registerNavFromMenu: false, title: i18n.t('app.user_detail') }
  },
  {
    path: 'trash/users/:id/historical',
    name: 'trash/users/historical',
    component: () => import('@/views/historical/TrashUserHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/users', registerNavFromMenu: false, title: i18n.t('historical.by_user') }
  },
  // {
  //   path: 'trash/tags',
  //   name: 'trash/tags',
  //   component: () => import('@/views/trash/Tags.vue'),
  //   meta: { registerNavFromMenu: false }
  // },
  // {
  //   path: 'trash/tags/:id/details',
  //   name: 'trash/tags/details',
  //   component: () => import('@/views/trash/Tag.vue'),
  //   meta: { secondaryMenu: 'configurations/trash/tags', registerNavFromMenu: false }
  // },
  {
    path: 'trash/groups',
    name: 'trash/groups',
    component: () => import('@/views/trash/Groups.vue'),
    meta: { registerNavFromMenu: false, title: i18n.t('trash.groups') }
  },
  {
    path: 'trash/groups/:id/details',
    name: 'trash/groups/details',
    component: () => import('@/views/trash/Group.vue'),
    meta: { secondaryMenu: 'configurations/trash/groups', registerNavFromMenu: false, title: i18n.t('app.group_detail') }
  },
  {
    path: 'trash/groups/:id/historical',
    name: 'trash/groups/historical',
    component: () => import('@/views/historical/TrashGroupHistorical.vue'),
    meta: { secondaryMenu: 'configurations/trash/groups', registerNavFromMenu: false, title: i18n.t('historical.by_group') }
  },
]
